import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';

import { LocalStorageService } from '../../../shared/services/local-storage/local-storage.service';
import { STORAGE_ENUM } from '../../enums/storage.enum';
import { AuthService } from '../../services/auth/auth.service';
import { SessionService } from '../../services/session/session.service';

export const authGuard: CanActivateFn = (route, state) => {
  const router = inject(Router);
  const authService = inject(AuthService);
  const localStorageService = inject(LocalStorageService);
  const sessionService = inject(SessionService);

  const token = localStorageService.get(STORAGE_ENUM.TOKEN);

  if (token) {
    sessionService.Token = localStorageService.get(STORAGE_ENUM.TOKEN);
    sessionService.User = localStorageService.get(STORAGE_ENUM.USER);
    sessionService.Customer = localStorageService.get(STORAGE_ENUM.CUSTOMER);
    sessionService.PortalUserId = localStorageService.get(STORAGE_ENUM.PORTAL_USER_ID);
    sessionService.CompanyStatus = localStorageService.get(STORAGE_ENUM.COMPANY);

    authService.verifyToken(token).subscribe({
      next: (response) => {
        if (response?.data?.company?.status?.key_string === 'company-blocked') {
          localStorageService.remove(STORAGE_ENUM.TOKEN);
          localStorageService.remove(STORAGE_ENUM.CUSTOMER);
          localStorageService.remove(STORAGE_ENUM.USER);
          localStorageService.remove(STORAGE_ENUM.PORTAL_USER_ID);
          localStorageService.remove(STORAGE_ENUM.COMPANY);

          router.navigate(['/login']);
          return false;
        }

        return true;
      },
      error: (error) => {
        console.error('Token is invalid', error);

        localStorageService.remove(STORAGE_ENUM.TOKEN);
        localStorageService.remove(STORAGE_ENUM.CUSTOMER);
        localStorageService.remove(STORAGE_ENUM.USER);
        localStorageService.remove(STORAGE_ENUM.PORTAL_USER_ID);
        localStorageService.remove(STORAGE_ENUM.COMPANY);

        router.navigate(['/login']);
        return false;
      }
    });

    return true;
  } else {
    router.navigate(['/login']);
    return false;
  }
};
